
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_17gpj_99",
  "root-with-toolbar": "awsui_root-with-toolbar_2qdw9_17gpj_138",
  "refresh": "awsui_refresh_2qdw9_17gpj_141",
  "root-no-actions": "awsui_root-no-actions_2qdw9_17gpj_141",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_17gpj_144",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_17gpj_144",
  "root-has-description": "awsui_root-has-description_2qdw9_17gpj_144",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_17gpj_153",
  "main": "awsui_main_2qdw9_17gpj_163",
  "no-wrap": "awsui_no-wrap_2qdw9_17gpj_173",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_17gpj_179",
  "actions": "awsui_actions_2qdw9_17gpj_187",
  "actions-centered": "awsui_actions-centered_2qdw9_17gpj_192",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_17gpj_195",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_17gpj_199",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_17gpj_203",
  "title": "awsui_title_2qdw9_17gpj_219",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_17gpj_224",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_17gpj_231",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_17gpj_237",
  "virtual-space": "awsui_virtual-space_2qdw9_17gpj_262",
  "info": "awsui_info_2qdw9_17gpj_268",
  "description": "awsui_description_2qdw9_17gpj_272",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_17gpj_279",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_17gpj_283",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_17gpj_290",
  "heading": "awsui_heading_2qdw9_17gpj_299",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_17gpj_310",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_17gpj_315",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_17gpj_320",
  "heading-text": "awsui_heading-text_2qdw9_17gpj_330",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_17gpj_333",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_17gpj_341",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_17gpj_349",
  "counter": "awsui_counter_2qdw9_17gpj_358"
};
  